// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Controlled.CheckBox {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
div.Controlled.CheckBox > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.Controlled.CheckBox > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.Controlled.CheckBox > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.Controlled.CheckBox.disabled {
  pointer-events: none;
  color: #697588;
}
div.Controlled.CheckBox > div.check {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #D3D6DF;
  padding: 0;
  margin-top: 8px;
  margin-right: 8px;
}
div.Controlled.CheckBox > div.check.checked {
  background-color: #01FF94;
}
div.Controlled.CheckBox > div.checkDisabled {
  background-color: #E8E9F0;
}
div.Controlled.CheckBox:hover > div.check, div.Controlled.CheckBox:active > div.check {
  border-color: #01FF94;
}
div.Controlled.CheckBox span.Label {
  width: calc(100% - 20px);
}
div.Controlled.CheckBox.labelLeft div.check {
  margin-left: 50%;
}
div.Controlled.CheckBox.labelLeft .Label {
  width: 50%;
}

.sepaAgree span {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/CheckBox/CheckBox.scss","webpack://./src/client/Global/InputBase.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;ECiBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AFKf;ACoBE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADIF;ACWE;EACE,UA9BS;EA+BT,gBA/BS;ADsBb;ACYE;EACE,kBAAA;ADVJ;AArBE;EACE,oBAAA;EACA,cE6CK;AFtBT;AApBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAsBJ;AApBI;EACE,yBEpBU;AF0ChB;AAlBE;EACE,yBE+BK;AFXT;AAhBI;EACE,qBE9BU;AFgDhB;AAdE;EACE,wBAAA;AAgBJ;AAZI;EACE,gBAAA;AAcN;AAXI;EACE,UAAA;AAaN;;AARA;EACE,sBAAA;AAWF","sourcesContent":["@import \"../../../Global/InputBase\";\n@import \"../../../Global/Colors.scss\";\n\ndiv.Controlled.CheckBox {\n  @include inputContainerRules;\n\n  &.disabled {\n    pointer-events: none;\n    color: $Gray90;\n  }\n\n  > div.check {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border: 1px solid $Gray50;\n    padding: 0;\n    margin-top: 8px;\n    margin-right: 8px;\n\n    &.checked {\n      background-color: $ElectricGreen;\n    }\n  }\n\n  > div.checkDisabled {\n    background-color: $Gray30;\n  }\n\n  &:hover, &:active {\n    > div.check {\n      border-color: $ElectricGreen;\n    }\n  }\n\n  span.Label {\n    width: calc(100% - 20px);\n  }\n\n  &.labelLeft {\n    div.check {\n      margin-left: 50%;\n    }\n\n    .Label {\n      width: 50%;\n    }\n  }\n}\n\n.sepaAgree span {\n  width: 100% !important;\n}\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
